module.exports = __webpack_public_path__ + "static/media/molpay.d01165df.png";